import { MessagePreviewOrderProps } from "../types"
import React from "react"
import PreviewWrap from "./preview-wrap"
import PreviewText from "./preview-text"
import { orderStatusText } from "~components/message/order-message"

const MessagePreviewOrder: React.FC<MessagePreviewOrderProps> = ({
  senderName,
  forwardPrependMsg,
  message,
}) => {
  const contentOverride = orderStatusText[message.attach.order.status]?.description
  return (
    <PreviewWrap>
      <PreviewText>
        {senderName}
        {forwardPrependMsg}
        {`[交易]`}
        {contentOverride}
      </PreviewText>
    </PreviewWrap>
  )
}
export default MessagePreviewOrder
